var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-container"},[_c('b-card',{attrs:{"title":"機台布局展示"}},[_c('div',{staticClass:"layout-demo"},[_c('sag-layout-machines',{attrs:{"layout-path":_vm.demoData.layoutPath,"machines":_vm.demoData.machines}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }